"use strict";

import { Injectable } from "@angular/core";
import { UpdatableService } from "../../../platform/base/services/updatable.service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Callback, IContent, IErrorObject, IQueryOption } from "../../../../../types/platform/universe";
import { retry } from "rxjs/operators";
import { Errors } from "../../base/library/errors";

@Injectable({
	providedIn: "root",
})
export class ShotdataDialogService extends UpdatableService {
	constructor(
		public http: HttpClient,
	) {
		super(http, "shots");
	}

	public delete(id: string, callback: Callback<any>): void {
		this.http.delete(this.endPoint + "/" + this.model + "/pseudo_delete/" + encodeURIComponent(id), this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(Errors.serverError(result, "A02937"), null);
						}
					} else {
						callback(Errors.httpError(500, "A00411"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00412"), null);
				},
				complete: () => {
				}
			}
		);
	}
	/**
		 * クエリー
		 *
		 * @param query MongoDBのクエリーオブジェクト
		 * @param option MongoDBのオプションオブジェクト
		 * @param callback 結果配列を返すコールバック
		 */
	public query(query: object, option: IQueryOption, callback: Callback<object[]>): void {
		callback(null, []);
	}

	/**
	 * カウント
	 *
	 * @param query MongoDBのクエリーオブジェクト
	 * @param callback 結果数を返すコールバック
	 */
	public count(query: object, callback: Callback<number>): void {
		callback(null, 0);
	}
}
